/* ============================================================================
   The Magical Underland — front-end interactivity (framework-free)
   Plain vanilla JS. No build step, no loader. Safe to open files directly.
   Handles: mobile menu, video muting, scroll parallax, reveal-on-scroll,
   FAQ accordions, and the sticky mobile buy bar.
   Every behaviour is progressive: with JS disabled the page is fully readable.
   ========================================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Mobile menu (slide-in drawer) --------------------------------- */
  function initMenu() {
    var burger = document.getElementById('mu-hamburger');
    var menu = document.getElementById('mu-mobile-menu');
    var backdrop = document.getElementById('mu-menu-backdrop');
    if (!menu) return;
    function set(open) {
      menu.classList.toggle('open', open);
      if (backdrop) backdrop.classList.toggle('open', open);
      if (burger) burger.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (burger) burger.addEventListener('click', function () {
      set(!menu.classList.contains('open'));
    });
    if (backdrop) backdrop.addEventListener('click', function () { set(false); });
    // close on any link click inside the drawer
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { set(false); });
    });
    // close button (×)
    menu.querySelectorAll('[data-close-menu], button').forEach(function (b) {
      b.addEventListener('click', function () { set(false); });
    });
  }

  /* ---- Force-mute every video (no audio on load) --------------------- */
  function initMute() {
    document.querySelectorAll('video').forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.volume = 0;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* ---- Scroll parallax + reveal -------------------------------------- */
  function initScroll() {
    var pimgs = [].slice.call(document.querySelectorAll('[data-px]'));   // oversized images inside overflow frames
    var ptext = [].slice.call(document.querySelectorAll('[data-pxt]'));  // headings / numbers
    var reveals = [].slice.call(document.querySelectorAll('[data-rev]'));

    // reveal setup
    if (!reduce && 'IntersectionObserver' in window) {
      reveals.forEach(function (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(46px) scale(.984)';
        el.style.filter = 'blur(7px)';
        el.style.transition =
          'opacity 1s cubic-bezier(.22,1,.36,1), transform 1.1s cubic-bezier(.22,1,.36,1), filter 1s cubic-bezier(.22,1,.36,1)';
      });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.style.opacity = '1';
          el.style.transform = 'none';
          el.style.filter = 'none';
          obs.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { obs.observe(el); });
    }

    if (reduce) return;

    function frame() {
      var vh = window.innerHeight;
      pimgs.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var f = parseFloat(el.getAttribute('data-px')) || 0.12;
        var center = r.top + r.height / 2;
        var room = r.height * 0.11;
        var ty = (center - vh / 2) * -f;
        ty = Math.max(-room, Math.min(room, ty));
        el.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0)';
      });
      ptext.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var f = parseFloat(el.getAttribute('data-pxt')) || 0.06;
        var center = r.top + r.height / 2;
        var ty = (center - vh / 2) * -f;
        ty = Math.max(-120, Math.min(120, ty));
        el.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0)';
      });
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { frame(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  }

  /* ---- FAQ / policy accordions --------------------------------------- */
  /* Any element with [data-accordion] toggles the next sibling panel.    */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      panel.style.overflow = 'hidden';
      panel.style.transition = 'max-height .3s ease';
      if (!btn.hasAttribute('data-open')) panel.style.maxHeight = '0px';
      var svg = btn.querySelector('svg');
      if (svg) svg.style.transition = 'transform .3s ease';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('data-open') === 'true';
        btn.setAttribute('data-open', open ? 'false' : 'true');
        panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
        if (svg) svg.style.transform = open ? 'none' : 'rotate(90deg)';
      });
    });
  }

  /* ---- Sticky mobile buy bar ----------------------------------------- */
  /* Shows #sticky-buybar once the main #buybox scrolls out of view.      */
  function initStickyBar() {
    var bar = document.getElementById('sticky-buybar');
    var box = document.getElementById('buybox');
    if (!bar || !box) return;
    function check() {
      var r = box.getBoundingClientRect();
      bar.style.transform = (r.bottom < 0) ? 'translateY(0)' : 'translateY(110%)';
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  function boot() {
    initMenu();
    initMute();
    initScroll();
    initAccordions();
    initStickyBar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();





















// FAQ Search Filter Only - No Accordion JS
(function() {
    'use strict';
    
    document.addEventListener('DOMContentLoaded', function() {
        const searchInput = document.querySelector('input[placeholder="Search answers..."], input[placeholder*="Search"]');
        
        if (!searchInput) return;
        
        // Get all FAQ items (the white cards)
        const faqItems = document.querySelectorAll('[data-screen-label="Questions"] div[style*="background:#ffffff"]');
        
        // Get all FAQ groups (the sections with headings)
        const faqGroups = document.querySelectorAll('[data-screen-label="Questions"] > div > div');
        
        // Search function
        function filterFAQs(searchTerm) {
            const term = searchTerm.toLowerCase().trim();
            
            // Filter FAQ items
            faqItems.forEach(item => {
                const button = item.querySelector('[data-accordion]');
                const questionText = button ? button.querySelector('span')?.textContent || '' : '';
                const answerText = item.querySelector('p')?.textContent || '';
                
                const match = term === '' || 
                             questionText.toLowerCase().includes(term) || 
                             answerText.toLowerCase().includes(term);
                
                item.style.display = match ? 'block' : 'none';
            });
            
            // Show/hide groups based on visible items
            faqGroups.forEach(group => {
                const visibleItems = group.querySelectorAll('[style*="display: block"]');
                group.style.display = visibleItems.length > 0 || term === '' ? 'flex' : 'none';
            });
            
            // Show/hide no results message
            let noResults = document.querySelector('.no-faq-results');
            const totalVisible = document.querySelectorAll('[data-screen-label="Questions"] div[style*="display: block"]').length;
            
            if (term !== '' && totalVisible === 0) {
                if (!noResults) {
                    noResults = document.createElement('p');
                    noResults.className = 'no-faq-results';
                    noResults.style.cssText = 'text-align:center;padding:30px 20px;font-size:16px;color:#6A6483;';
                    const container = document.querySelector('[data-screen-label="Questions"] > div');
                    if (container) container.appendChild(noResults);
                }
                noResults.textContent = 'No results found for "' + searchTerm + '"';
                noResults.style.display = 'block';
            } else if (noResults) {
                noResults.style.display = 'none';
            }
        }
        
        // Debounce function for better performance
        function debounce(func, wait) {
            let timeout;
            return function(...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), wait);
            };
        }
        
        // Add search event listener with debounce
        const debouncedFilter = debounce(function(e) {
            filterFAQs(e.target.value);
        }, 300);
        
        searchInput.addEventListener('input', debouncedFilter);
        
        // Handle Enter key
        searchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                filterFAQs(this.value);
            }
        });
        
        // Search icon click focuses input
        const searchIcon = searchInput.parentElement?.querySelector('svg');
        if (searchIcon) {
            searchIcon.style.cursor = 'pointer';
            searchIcon.addEventListener('click', () => searchInput.focus());
        }
        
        // Initialize - show all
        filterFAQs('');
    });
})();











  // Product configuration - Change these values to control product state
  const productConfig = {
    // Set to 'true' for OUT OF STOCK, 'false' for IN STOCK
    isOutOfStock: false,
    
    // Set to 'true' to show pre-order option when out of stock
    allowPreorder: true,
    
    // Stock count (only shown when in stock)
    stockCount: 32
  };
  
  // Update UI based on stock status
  function updateStockStatus() {
    const availabilityEl = document.getElementById('availabilityStatus');
    const availabilityText = document.getElementById('availabilityText');
    
    if (productConfig.isOutOfStock) {
      // OUT OF STOCK
      availabilityEl.classList.add('out-of-stock');
      
      if (productConfig.allowPreorder) {
        availabilityText.innerHTML = '❗ Out of Stock — <span class="preorder-text">You can now Pre-Order</span>';
      } else {
        availabilityText.textContent = '❗ Out of Stock';
      }
    } else {
      // IN STOCK
      availabilityEl.classList.remove('out-of-stock');
      availabilityText.textContent = `❗ Only ${productConfig.stockCount} left. Order soon!`;
    }
  }
  
  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    updateStockStatus();
  });




